import {
  Serializer, QuestionPanelDynamicModel,
} from 'survey-core';

const TRADE_REFERENCES_QUESTION_TYPE = 'trade-references';

// The Trade Reference question is simply a wrapper/copy of the Dynamic Panel question type.
Serializer.addClass(
  TRADE_REFERENCES_QUESTION_TYPE,
  [],
  () => new QuestionPanelDynamicModel(''),
  'paneldynamic',
);

export const registerTradeReferencesQuestion = () => {
  // Serializer.addClass() is all we need for now and it is called at module level
};
